export const CertificatesTypes = {
	CONSUMPTION: {label: "Consumption", value: 0},
	PRODUCTION: {label: "Production", value: 1},
	IREC: {label: "IRec", value: 2}
}


// WEBPACK FOOTER //
// ./src/enums/CertificatesTypes.js